<template>
    <UIExampleIncompleteNotice></UIExampleIncompleteNotice>
    <p>
        Use an alert to help users identify and understand important content on the page.
    </p>
    <UIExampleContainer :componentId="'AlertInformation'" :name="'Information Alert'" :vueComponent="infoVueComponent" :vueCode="infoVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>
    <UIExampleContainer :componentId="'AlertNegative'" :name="'Negative Alert'" :vueComponent="negVueComponent" :vueCode="negVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>
    <UIExampleContainer :componentId="'AlertPositive'" :name="'Positive Alert'" :vueComponent="posVueComponent" :vueCode="posVueCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>
</template>

<script>
    import { defineComponent } from 'vue';
    import { default as UIExampleIncompleteNotice } from '../UIExampleIncompleteNotice.vue';
    import { default as UIExampleContainer } from '../../UIExampleContainer.vue';

    import { default as ExampleInformationComponent } from './InformationAlert.vue';
    import ExampleInformationCode from '!!raw-loader!./InformationAlert.vue';
    import { default as ExampleNegativeComponent } from './NegativeAlert.vue';
    import ExampleNegativeCode from '!!raw-loader!./NegativeAlert.vue';
    import { default as ExamplePositiveComponent } from './PositiveAlert.vue';
    import ExamplePositiveCode from '!!raw-loader!./PositiveAlert.vue';


    export default defineComponent({
        name: "Alerts",
        components: {
            UIExampleIncompleteNotice,
            UIExampleContainer
        },
        setup(_props, _context) {
            return {
                infoVueComponent: ExampleInformationComponent,
                infoVueCode: ExampleInformationCode,
                negVueComponent: ExampleNegativeComponent,
                negVueCode: ExampleNegativeCode,
                posVueComponent: ExamplePositiveComponent,
                posVueCode: ExamplePositiveCode
            }
        }
    });
</script>